import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '@sharedComponents/Typography';
import { useEffect, useRef, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { animated, useSpring } from 'react-spring';

import * as style from './style.module.css';

const Accordion = withTranslation()(({ title, children, t, type = 'default' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const contentRef = useRef(null);
    const [contentHeight, setContentHeight] = useState(0);

    useEffect(() => {
        if (contentRef.current) {
            setContentHeight(contentRef.current.scrollHeight);
        }
    }, [children, isOpen]);

    const handleAccordionClick = () => {
        setIsOpen(!isOpen);
    };

    const animation = useSpring({
        opacity: isOpen ? 1 : 0,
        maxHeight: isOpen ? contentHeight : 0,
        overflow: 'hidden',
        config: {
            tension: 300,
            friction: 30,
        },
    });

    return (
        <div className={style.accordion}>
            <button className={style.accordionBtn} onClick={handleAccordionClick}>
                {type === 'default' && (
                    <Typography color={'neutral-primary'} fontWeight="regular">
                        {t(`${title}`)}
                    </Typography>
                )}
                {type === 'SECTION' && (
                    <Typography fontSize="xs" fontWeight="regular" color={'neutral-secondary'} className={style.sectionTitle}>
                        {title}
                    </Typography>
                )}
                <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} color="black" />
            </button>

            <animated.div style={animation} className={`${style.accordionContent} ${isOpen ? style.isVisible : ''}`}>
                <div ref={contentRef}>
                    <Typography color={'neutral-secondary'} fontWeight="regular" span>
                        {children}
                    </Typography>
                </div>
            </animated.div>
        </div>
    );
});

export default Accordion;
